import { PropTypes } from "prop-types"
import _ from "lodash"
import classNames from "classnames"

import Button from "../Button"

const Tab = ({ children, disabled, name, selected, value, onClick, onKeyDown, className = "" }) => (
  <Button
    aria-selected={selected}
    className={classNames("oj-tab", className, _.kebabCase(value), { selected })}
    role="tab"
    tabIndex={selected ? 0 : -1}
    disabled={disabled}
    id={`tab-list-${value}`}
    aria-controls={`${name}-${_.kebabCase(value)}-panel`}
    onClick={onClick}
    onKeyDown={onKeyDown}
    value={value}
  >
    {children}
  </Button>
)

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired
}

export default Tab
